module.exports = __webpack_public_path__ + "static/media/spinner.ab7c4741.svg";